import { type BulkVerb, bulkSnackbarCopy } from './action-labels';

/** Minimal subset of Pluma's `useSnackbars()` API used by the choreography. */
export interface BulkSnackbarsApi {
  create: (props: {
    id?: string;
    message: string;
    variant?: 'default' | 'success' | 'error';
    autoCloseTimeout?: number;
  }) => unknown;
  destroy: (id: string) => void;
}

/**
 * The three-state snackbar choreography for a bulk delivery op, ported from the
 * Ember `_complete`: show a persistent "…soon" snackbar (no auto-close), run
 * the op, then replace it with the auto-dismissing success snackbar; on failure
 * just remove the persistent one (no error toast — matching Ember). Errors are
 * swallowed so a fire-and-forget caller doesn't reject.
 */
export async function runBulkVerb(
  snackbars: BulkSnackbarsApi,
  verb: BulkVerb,
  itemLabel: string,
  count: number,
  run: () => Promise<unknown>,
): Promise<void> {
  const { pending, success } = bulkSnackbarCopy(verb, itemLabel, count);
  const id = `delivery-${verb}`;
  snackbars.create({ id, message: pending, autoCloseTimeout: 0 });
  try {
    await run();
    snackbars.destroy(id);
    snackbars.create({ variant: 'success', message: success });
  } catch {
    snackbars.destroy(id);
  }
}
